import PeopleSingleLarge from "graphics/icons/PeopleSingleLarge";
import PeopleSingleSmall from "graphics/icons/PeopleSingleSmall";
import PeopleSingleSmallLight from "graphics/icons/PeopleSingleSmallLight";
import React from "react";

const EfficeTitlePresence = ({ ppl, large = false, light = false }) => {
  return (
    <div
      className={`${
        large ? "effice-title-presence-large" : "effice-title-presence"
      }`}
    >
      <div
        className={`${light ? "white-text" : ""} ${
          large
            ? "effice-title-presence-number-large"
            : "effice-title-presence-number"
        }`}
      >
        {ppl}
      </div>
      {light ? (
        <PeopleSingleSmallLight />
      ) : large ? (
        <PeopleSingleLarge />
      ) : (
        <PeopleSingleSmall />
      )}
    </div>
  );
};

export default EfficeTitlePresence;
